/** Traductions Admin Dashboard (FR / AR) */
export const adminDashboardFr = {
  shellBrand: 'AMAN Platform',
  title: 'Admin Dashboard',
  subtitle: 'Gestion des entreprises',
  refresh: 'Actualiser',
  logout: 'Déconnexion',
  loading: 'Chargement...',
  close: 'Fermer',
  closeAria: 'Fermer',
  cancel: 'Annuler',
  next: 'Suivant',
  back: 'Retour',
  confirm: 'Confirmer',
  understood: '✅ Compris',
  notDefined: 'Non défini',
  notSpecified: 'Non spécifié',
  summary: 'Résumé',
  currency: 'MRU',

  tempHintTitle: 'Liste Supabase (cloud uniquement)',
  tempHintP1:
    'Cette liste ne montre que les entreprises dans la table Supabase businesses. Les comptes purement locaux sur un PC ne sont pas administrables ici.',
  tempHintP2: 'Connexion admin Supabase : ajoutez dans .env puis reconstruisez l\'app : REACT_APP_SUPABASE_ADMIN_EMAIL et REACT_APP_SUPABASE_ADMIN_PASSWORD (utilisateur Auth lié à la table admin_users), pour que les politiques RLS autorisent la lecture de businesses.',
  tempHintLoadError: 'Dernière erreur de chargement : {{error}}',
  errorAdminJwtNotConfigured:
    'JWT admin Supabase manquant : définissez REACT_APP_SUPABASE_ADMIN_EMAIL / PASSWORD (Auth + table admin_users), puis reconstruisez.',
  errorAdminJwtFailed: 'Connexion admin Supabase refusée : {{error}}',
  errorInvalidAdminCredentials:
    'Mot de passe / e-mail admin invalides pour Supabase Auth ({{email}}). TEMP_ADMIN_* ouvre seulement l’écran local. Créez l’utilisateur sous Authentication → Users avec le même e-mail/mot de passe que REACT_APP_SUPABASE_ADMIN_*, puis : insert into public.admin_users (auth_user_id) select id from auth.users where email = \'{{email}}\' on conflict do nothing; Redémarrez l’app après .env.',
  errorNotInAdminUsers:
    'Auth OK ({{email}}) mais pas dans la table admin_users — RLS masque toutes les entreprises. Dans Supabase SQL Editor exécutez : insert into public.admin_users (auth_user_id) select id from auth.users where email = \'{{email}}\' on conflict (auth_user_id) do nothing; puis Actualiser.',
  errorEmptyMaybeRls:
    'Aucune entreprise cloud (table businesses vide, ou JWT admin / admin_users incorrect).',
  errorCloudEmptyPendingLocal:
    'Aucune ligne cloud. {{count}} compte(s) local(aux) sur CE PC en attente de push Supabase — utilisez le magasin en ligne ou login magasin pour envoyer l’inscription.',
  adminCloudOnlyHint:
    'Liste = Supabase uniquement. {{count}} compte(s) encore local(aux) sur ce PC (pas affichés ici tant qu’ils ne sont pas dans businesses).',
  errorLocalOnlyReview:
    'Cette inscription n’est pas dans Supabase — impossible d’approuver. Sur le PC du magasin : connexion internet + login (push cloud), puis actualisez l’admin.',
  errorCloudEmptyLocalOnly:
    'Aucune fiche Supabase. {{count}} compte(s) local(aux) sur CE PC seulement — non listés ici (admin = cloud only).',
  sourceLocal: 'LOCAL',
  sourceCloud: 'CLOUD',
  sourceLocalHint:
    'Non listé dans l’admin (cloud only). Push cloud requis depuis le magasin.',
  sourceCloudHint: 'Ligne dans la table Supabase businesses (admin JWT).',
  errorNoInternet: 'Pas de connexion Internet',
  errorLoadFailed: 'Chargement des entreprises échoué',
  errorUnknown: 'Erreur inconnue',

  statTotal: 'Total Entreprises',
  statPending: 'En Attente',
  statActive: 'Abonnements Actifs',
  statExpired: 'Abonnements Expirés',
  statMonthly: 'Abonnements Mensuels',
  statYearly: 'Abonnements Annuels',
  statPlans: 'Mensuel / Annuel',
  statSuspended: 'Suspendues',

  searchPlaceholder: 'Rechercher par nom, propriétaire, email...',
  filterAll: 'Tous les statuts',
  filterPending: 'En attente',
  filterApproved: 'Approuvées',
  filterSuspended: 'Suspendues',
  filterExpired: 'Expirées',

  colBusiness: 'Entreprise',
  colType: 'Type',
  colOwner: 'Propriétaire',
  colContact: 'Contact',
  colRegistration: 'Date d\'inscription',
  colSubscription: 'Abonnement',
  colNextPayment: 'Prochain paiement',
  colStatus: 'Statut',
  colActions: 'Actions',
  noResults: 'Aucune entreprise trouvée',
  noData: 'Aucune entreprise enregistrée',

  subMonthly: 'Mensuel',
  subYearly: 'Annuel',
  subExpires: 'Expire: {{date}}',
  perMonth: 'mois',
  perYear: 'an',
  priceMonthlyDefault: '50 MRU/mois',
  priceYearlyDefault: '500 MRU/an',

  statusPending: 'En attente',
  statusApproved: 'Approuvée',
  statusSuspended: 'Suspendue',

  countdownExpired: 'Expiré ({{days}}j)',
  countdownToday: 'Aujourd\'hui',
  countdownTomorrow: 'Demain',
  countdownDays: '{{days}} jours',

  tooltipEditSubscription: 'Modifier l\'abonnement',
  tooltipEditStatus: 'Modifier le statut',
  tooltipReactivate: 'Réactiver l\'entreprise',
  tooltipViewDetails: 'Voir les détails',
  tooltipReview: 'Réviser la demande',
  tooltipDelete: 'Supprimer l\'entreprise',
  tooltipReport: 'Voir le rapport 28 jours',
  tooltipRegenUnlock: 'Régénérer le code de déverrouillage',

  detailsTitle: 'Détails de l\'entreprise',
  sectionBasic: 'Informations de base',
  sectionContact: 'Contact',
  sectionAccount: 'Compte',
  sectionBusinessType: 'Type d\'entreprise',
  labelBusinessName: 'Nom de l\'entreprise',
  labelOwner: 'Propriétaire',
  labelNif: 'NIF',
  labelAddress: 'Adresse',
  labelLogo: 'Logo de l\'entreprise',
  labelEmail: 'Email',
  labelPhone: 'Téléphone',
  labelUsername: 'Nom d\'utilisateur',
  labelRegistrationDate: 'Date d\'inscription',
  labelApprovalDate: 'Date d\'approbation',
  labelManagerCode: 'Code Manager',
  managerCodePresent: 'Défini (hash sécurisé)',
  managerCodeMissing: 'Non défini dans Supabase',
  managerCodeHintSecure:
    'Le code n’est pas affiché en clair — seul un hash PBKDF2 est stocké. Le commerçant peut le repousser via Réglages → code manager.',
  managerCodeHintMissing:
    'NULL en base : inscription/upgrade avant le fix, ou jamais enregistré. Sur le PC du magasin : se connecter et ré-enregistrer le code manager (paramètres employés).',
  labelUnlockCode: 'Code de Déverrouillage d\'Urgence',
  regenerate: 'Régénérer',

  subModalApprove: 'Approuver avec abonnement',
  subModalRenew: 'Renouveler l\'abonnement',
  chooseSubType: 'Choisir le type d\'abonnement',
  subMonthlyTitle: 'Abonnement Mensuel',
  subMonthlyDesc: 'Renouvellement automatique chaque mois',
  subMonthlyPrice: 'Prix: 50 MRU/mois',
  subYearlyTitle: 'Abonnement Annuel',
  subYearlyDesc: 'Renouvellement automatique chaque année',
  subYearlyPrice: 'Prix: 500 MRU/an (Économie: 100 MRU)',
  customAmount: 'Montant personnalisé (MRU)',
  amountPlaceholder: 'Entrez le montant en MRU',
  amountPlaceholderPeriod: 'Entrez le montant en MRU/{{period}}',
  amountNoteDefault: 'Laissez vide pour utiliser le montant par défaut ({{default}})',
  amountNotePeriod: 'Entrez le montant pour l\'abonnement {{type}}',
  summaryBusiness: 'Entreprise:',
  summarySubType: 'Type d\'abonnement:',
  summaryCloudPlan: 'Offre cloud:',
  summaryPrice: 'Prix:',
  summaryOwner: 'Propriétaire:',
  summaryBusinessType: 'Type d\'entreprise:',
  summaryDecision: 'Décision:',
  approve: 'Approuver',
  renew: 'Renouveler',

  cloudPlanLabel: 'Cloud',
  cloudPlanNone: 'Local uniquement',
  cloudPlanMirror: 'Cloud Mirror',
  cloudPlanHybrid: 'Hybrid multi-appareils',
  cloudPlanChoose: 'Offre cloud (optionnelle)',
  cloudPlanNoneTitle: 'Local uniquement',
  cloudPlanNoneDesc: 'ERP hors ligne — pas de synchronisation ventes/achats/rapports vers le cloud.',
  cloudPlanMirrorTitle: 'Cloud Mirror',
  cloudPlanMirrorDesc: 'Pousse ventes, achats et rapports vers Supabase pour l\'admin (POS reste local).',
  cloudPlanHybridTitle: 'Hybrid multi-appareils',
  cloudPlanHybridDesc:
    'Mirror + sync catalogue (produits, clients, fournisseurs, lots) entre plusieurs caisses. Le stock local reste la référence.',

  reviewTitle: 'Révision de demande - {{name}}',
  step1Title: 'Étape 1: Choisir la décision',
  step2Title: 'Étape 2: Choisir le type d\'abonnement',
  step3Title: 'Étape 3: Confirmation finale',
  reviewApproveTitle: 'Approuver l\'entreprise',
  reviewApproveDesc: 'Accorder l\'accès au système avec un abonnement',
  reviewSuspendTitle: 'Suspendre l\'entreprise',
  reviewSuspendDesc: 'Refuser l\'accès au système pour le moment',
  decisionApprove: '✅ Approuver',
  decisionSuspend: '❌ Suspendre',
  decisionApproveLabel: 'Approuver',
  finalSummary: 'Résumé complet de la décision',
  labelExpiryDate: 'Date d\'expiration:',
  irreversibleAction: 'Action irréversible',
  confirmApproveQuestion: 'Êtes-vous absolument sûr de vouloir approuver cette entreprise ?',
  confirmSuspendQuestion: 'Êtes-vous absolument sûr de vouloir suspendre cette entreprise ?',
  approveWarningNote: 'Cette action accordera l\'accès complet au système avec un abonnement actif.',
  suspendWarningNote: 'Cette action désactivera temporairement l\'accès au système pour cette entreprise.',

  statusModalTitle: 'Modifier le statut - {{name}}',
  chooseNewStatus: 'Choisir le nouveau statut',
  suspendBusiness: 'Suspendre l\'entreprise',
  suspendDesc: 'Désactiver temporairement l\'accès au système',
  reactivateBusiness: 'Réactiver l\'entreprise',
  reactivateDesc: 'Réactiver l\'accès au système',
  currentStatus: 'Statut actuel:',
  currentSubscription: 'Abonnement actuel:',
  reactivate: 'Réactiver',
  suspend: 'Suspendre',

  deleteTitle: '🗑️ Supprimer l\'entreprise',
  deleteWarning: 'Vous êtes sur le point de supprimer définitivement cette entreprise et toutes ses données.',
  deleteDetailsTitle: 'Détails de l\'entreprise à supprimer',
  deleteConsequencesTitle: '⚠️ Conséquences de la suppression',
  deleteConsequence1: 'Toutes les données de l\'entreprise seront définitivement supprimées',
  deleteConsequence2: 'Tous les produits, ventes, achats, clients et fournisseurs seront perdus',
  deleteConsequence3: 'L\'entreprise ne pourra plus accéder au système',
  deleteConsequence4: 'Cette action ne peut pas être annulée',
  deleteConfirmCheckbox: 'Je comprends que cette action est irréversible et je confirme vouloir supprimer cette entreprise',
  deleteConfirmButton: '🗑️ Supprimer définitivement',

  deleteSuccessTitle: '✅ Suppression réussie',
  deleteSuccessHeading: 'Entreprise supprimée avec succès',
  deleteSuccessMessage: 'L\'entreprise "{{name}}" a été définitivement supprimée du système.',
  deleteSuccessActionsTitle: 'Actions effectuées :',
  deleteSuccessAction1: '✅ Suppression de l\'entreprise de la base de données',
  deleteSuccessAction2: '✅ Suppression de toutes les données associées',
  deleteSuccessAction3: '✅ Nettoyage du stockage local',
  deleteSuccessAction4: '✅ Mise à jour de la liste des entreprises',
  deleteSuccessNote: 'Note : Cette action est irréversible. L\'entreprise ne peut plus accéder au système.',

  reviewSuccessApproveTitle: '✅ Approbation réussie',
  reviewSuccessSuspendTitle: '❌ Suspension réussie',
  reviewSuccessApproveHeading: 'Entreprise approuvée avec succès',
  reviewSuccessSuspendHeading: 'Entreprise suspendue avec succès',
  reviewSuccessMessage: 'L\'entreprise "{{name}}" a été {{action}} avec succès.',
  actionApproved: 'approuvée',
  actionSuspended: 'suspendue',
  approvalDetailsTitle: 'Détails de l\'approbation :',
  approvalStatusUpdated: '✅ Statut mis à jour :',
  approvalSubType: '✅ Type d\'abonnement :',
  approvalAmount: '✅ Montant :',
  approvalDate: '✅ Date d\'approbation :',
  approvalBy: '✅ Approuvé par :',
  approvalPaid: '✅ Paiement :',
  paid: 'Payé',
  suspendDetailsTitle: 'Détails de la suspension :',
  suspendStatusUpdated: '❌ Statut mis à jour :',
  suspendDate: '❌ Date de suspension :',
  suspendBy: '❌ Suspendue par :',
  suspendAccess: '❌ Accès au système :',
  blocked: 'Bloqué',

  unlockSuccessTitle: '🔑 Code régénéré',
  unlockSuccessHeading: 'Code de déverrouillage régénéré',
  unlockSuccessNote: 'Note : Le nouveau code est maintenant actif et peut être utilisé pour déverrouiller le système en cas d\'urgence.',

  errorClose: '❌ Fermer',
  errorTitle: 'Erreur',
  errorNoInternet: 'Pas de connexion Internet.',
  errorLoadFailed: 'Chargement impossible.',
  errorUnknown: 'Erreur inconnue.',
  errorReportGen: 'Erreur lors de la génération du rapport',
  errorReportGenWith: 'Erreur lors de la génération du rapport: {{error}}',
  errorUnlockRegen: 'Erreur lors de la régénération du code de déverrouillage',
  errorUnlockRegenWith: 'Erreur lors de la régénération: {{error}}',
  unlockRegenSuccess: 'Code de déverrouillage régénéré avec succès: {{code}}',
  errorPdfFailed: 'Échec de la génération du PDF',
  errorUpdateTitle: 'Erreur de mise à jour',
  errorUpdateFailed: 'Échec de la mise à jour du statut de l\'entreprise: {{error}}',
  errorGeneric: 'Une erreur s\'est produite: {{message}}',
  errorSuspendTitle: 'Erreur de suspension',
  errorSuspendFailed: 'Échec de la suspension de l\'entreprise. Veuillez réessayer.',
  errorActivateTitle: 'Erreur d\'activation',
  errorActivateFailed: 'Échec de l\'activation de l\'entreprise. Veuillez réessayer.',
  errorRetry: 'Une erreur s\'est produite. Veuillez réessayer.',
  errorDeleteTitle: 'Erreur de suppression',
  errorDeleteFailed: 'Échec de la suppression: {{error}}',
  errorDeleteGeneric: 'Une erreur est survenue. Veuillez vérifier votre connexion et réessayer.',
  errorBusinessNotFoundTitle: 'Entreprise non trouvée',
  errorBusinessNotFound: 'L\'entreprise demandée n\'a pas été trouvée.',
  errorNoStatusSelected: 'Aucun statut sélectionné',
  errorSelectStatus: 'Veuillez sélectionner un statut avant de continuer.',

  reportLoadingTitle: 'Chargement du rapport...',
  reportLoadingDesc: 'Chargement des données depuis Supabase...',
  reportNoDataTitle: 'Aucune donnée disponible',
  reportNoDataDesc1: 'Aucune donnée de rapport trouvée pour cette entreprise.',
  reportNoDataDesc2: 'L\'entreprise doit se connecter et synchroniser ses données avec Supabase.',
  reportTitle: 'Rapport 28 jours - {{name}}',
  reportPeriod: 'Période:',
  reportPeriodRange: 'Du {{start}} au {{end}}',
  reportBusiness: 'Entreprise:',
  reportStockTitle: 'Mouvement de stock sur 28 jours',
  reportPoultryTitle: 'Résumé du cycle avicole sur 28 jours',
  reportColProduct: 'PRODUIT',
  reportColSuppliers: 'FOURNISSEURS',
  reportColCustomers: 'CLIENTS',
  reportColPurchased: 'ACHETÉ',
  reportColSold: 'VENDU',
  reportColInStock: 'EN STOCK',
  reportColPurchasePrice: 'PRIX ACHAT',
  reportColSellingPrice: 'PRIX VENTE',
  reportColMetric: 'MÉTRIQUE',
  reportColQuantity: 'QUANTITÉ/VALEUR',
  reportColDescription: 'DESCRIPTION',
  poultryPurchasedLive: 'Poulets vivants achetés',
  poultrySoldLive: 'Poulets vivants vendus',
  poultrySoldSlaughtered: 'Poulets abattus vendus',
  poultryPurchasedLiveDesc: 'Poulets vivants achetés sur les 28 derniers jours',
  poultrySoldLiveDesc: 'Poulets vivants vendus sur les 28 derniers jours',
  poultrySoldSlaughteredDesc: 'Poulets abattus vendus sur les 28 derniers jours'
};

export const adminDashboardAr = {
  shellBrand: 'AMAN Platform',
  title: 'لوحة الإدارة',
  subtitle: 'إدارة المؤسسات',
  refresh: 'تحديث',
  logout: 'تسجيل الخروج',
  loading: 'جاري التحميل...',
  close: 'إغلاق',
  closeAria: 'إغلاق',
  cancel: 'إلغاء',
  next: 'التالي',
  back: 'رجوع',
  confirm: 'تأكيد',
  understood: '✅ فهمت',
  notDefined: 'غير محدد',
  notSpecified: 'غير محدد',
  summary: 'ملخص',
  currency: 'أوقية',

  tempHintTitle: 'قائمة Supabase (سحابة فقط)',
  tempHintP1:
    'هذه القائمة تعرض فقط المؤسسات من جدول businesses في Supabase. الحسابات المحلية على جهاز المتجر غير قابلة للإدارة هنا.',
  tempHintP2: 'اتصال إدارة Supabase: أضف في .env ثم أعد بناء التطبيق: REACT_APP_SUPABASE_ADMIN_EMAIL و REACT_APP_SUPABASE_ADMIN_PASSWORD (مستخدم Auth مرتبط بجدول admin_users)، لتسمح سياسات RLS بقراءة businesses.',
  tempHintLoadError: 'آخر خطأ في التحميل: {{error}}',
  errorAdminJwtNotConfigured:
    'رمز JWT لمسؤول Supabase غير مضبوط: عيّن REACT_APP_SUPABASE_ADMIN_EMAIL / PASSWORD (Auth + جدول admin_users) ثم أعد البناء.',
  errorAdminJwtFailed: 'تم رفض اتصال مسؤول Supabase: {{error}}',
  errorInvalidAdminCredentials:
    'بريد/كلمة مرور المسؤول غير صحيحة في Supabase Auth ({{email}}). TEMP_ADMIN_* يفتح الشاشة المحلية فقط. أنشئ المستخدم في Authentication → Users بنفس REACT_APP_SUPABASE_ADMIN_* ثم: insert into public.admin_users (auth_user_id) select id from auth.users where email = \'{{email}}\' on conflict do nothing; أعد تشغيل التطبيق بعد .env.',
  errorNotInAdminUsers:
    'تسجيل الدخول Auth نجح ({{email}}) لكن الحساب غير موجود في admin_users — RLS يخفي كل الشركات. نفّذ في SQL Editor: insert into public.admin_users (auth_user_id) select id from auth.users where email = \'{{email}}\' on conflict (auth_user_id) do nothing; ثم حدّث الصفحة.',
  errorEmptyMaybeRls:
    'لا مؤسسات سحابية (جدول businesses فارغ، أو JWT المسؤول / admin_users غير صحيح).',
  errorCloudEmptyPendingLocal:
    'لا صفوف سحابية. {{count}} حساب(ات) محلية على هذا الجهاز بانتظار الدفع إلى Supabase — شغّل المتجر أونلاين أو سجّل الدخول لإرسال التسجيل.',
  adminCloudOnlyHint:
    'القائمة = Supabase فقط. {{count}} حساب(ات) ما زالت محلية على هذا الجهاز (لا تظهر هنا حتى تدخل businesses).',
  errorLocalOnlyReview:
    'هذا التسجيل ليس في Supabase — لا يمكن الموافقة. على جهاز المتجر: إنترنت + تسجيل دخول (دفع سحابي)، ثم حدّث لوحة المسؤول.',
  errorCloudEmptyLocalOnly:
    'لا صفوف Supabase. {{count}} حساب(ات) محلية على هذا الجهاز فقط — غير مدرجة هنا (المسؤول = سحابة فقط).',
  sourceLocal: 'محلي',
  sourceCloud: 'سحابة',
  sourceLocalHint:
    'غير مدرج في لوحة المسؤول (سحابة فقط). يلزم الدفع السحابي من المتجر.',
  sourceCloudHint: 'صف في جدول businesses على Supabase (JWT المسؤول).',
  errorNoInternet: 'لا يوجد اتصال بالإنترنت',
  errorLoadFailed: 'فشل تحميل المؤسسات',
  errorUnknown: 'خطأ غير معروف',

  statTotal: 'إجمالي المؤسسات',
  statPending: 'في الانتظار',
  statActive: 'اشتراكات نشطة',
  statExpired: 'اشتراكات منتهية',
  statMonthly: 'اشتراكات شهرية',
  statYearly: 'اشتراكات سنوية',
  statPlans: 'شهري / سنوي',
  statSuspended: 'معلّقة',

  searchPlaceholder: 'البحث بالاسم، المالك، البريد...',
  filterAll: 'جميع الحالات',
  filterPending: 'في الانتظار',
  filterApproved: 'موافق عليها',
  filterSuspended: 'معلّقة',
  filterExpired: 'منتهية',

  colBusiness: 'المؤسسة',
  colType: 'النوع',
  colOwner: 'المالك',
  colContact: 'الاتصال',
  colRegistration: 'تاريخ التسجيل',
  colSubscription: 'الاشتراك',
  colNextPayment: 'الدفعة القادمة',
  colStatus: 'الحالة',
  colActions: 'إجراءات',
  noResults: 'لم يتم العثور على مؤسسة',
  noData: 'لا توجد مؤسسات مسجلة',

  subMonthly: 'شهري',
  subYearly: 'سنوي',
  subExpires: 'ينتهي: {{date}}',
  perMonth: 'شهر',
  perYear: 'سنة',
  priceMonthlyDefault: '50 أوقية/شهر',
  priceYearlyDefault: '500 أوقية/سنة',

  statusPending: 'في الانتظار',
  statusApproved: 'موافق عليها',
  statusSuspended: 'معلّقة',

  countdownExpired: 'منتهي ({{days}} ي)',
  countdownToday: 'اليوم',
  countdownTomorrow: 'غداً',
  countdownDays: '{{days}} أيام',

  tooltipEditSubscription: 'تعديل الاشتراك',
  tooltipEditStatus: 'تعديل الحالة',
  tooltipReactivate: 'إعادة تفعيل المؤسسة',
  tooltipViewDetails: 'عرض التفاصيل',
  tooltipReview: 'مراجعة الطلب',
  tooltipDelete: 'حذف المؤسسة',
  tooltipReport: 'عرض تقرير 28 يوماً',
  tooltipRegenUnlock: 'إعادة توليد رمز الفتح',

  detailsTitle: 'تفاصيل المؤسسة',
  sectionBasic: 'معلومات أساسية',
  sectionContact: 'الاتصال',
  sectionAccount: 'الحساب',
  sectionBusinessType: 'نوع المؤسسة',
  labelBusinessName: 'اسم المؤسسة',
  labelOwner: 'المالك',
  labelNif: 'الرقم الضريبي',
  labelAddress: 'العنوان',
  labelLogo: 'شعار المؤسسة',
  labelEmail: 'البريد الإلكتروني',
  labelPhone: 'الهاتف',
  labelUsername: 'اسم المستخدم',
  labelRegistrationDate: 'تاريخ التسجيل',
  labelApprovalDate: 'تاريخ الموافقة',
  labelManagerCode: 'رمز المدير',
  managerCodePresent: 'معرّف (تجزئة آمنة)',
  managerCodeMissing: 'غير معرّف في Supabase',
  managerCodeHintSecure:
    'لا يُعرض الرمز كنص — تُخزَّن تجزئة PBKDF2 فقط. يمكن للتاجر إعادة حفظه من الإعدادات → كود المدير.',
  managerCodeHintMissing:
    'NULL في القاعدة: تسجيل/ترقية قبل الإصلاح أو لم يُحفظ. على جهاز المتجر: سجّل الدخول وأعد حفظ كود المدير.',
  labelUnlockCode: 'رمز فتح الطوارئ',
  regenerate: 'إعادة التوليد',

  subModalApprove: 'الموافقة مع اشتراك',
  subModalRenew: 'تجديد الاشتراك',
  chooseSubType: 'اختر نوع الاشتراك',
  subMonthlyTitle: 'اشتراك شهري',
  subMonthlyDesc: 'تجديد تلقائي كل شهر',
  subMonthlyPrice: 'السعر: 50 أوقية/شهر',
  subYearlyTitle: 'اشتراك سنوي',
  subYearlyDesc: 'تجديد تلقائي كل سنة',
  subYearlyPrice: 'السعر: 500 أوقية/سنة (توفير: 100 أوقية)',
  customAmount: 'مبلغ مخصص (أوقية)',
  amountPlaceholder: 'أدخل المبلغ بالأوقية',
  amountPlaceholderPeriod: 'أدخل المبلغ بالأوقية/{{period}}',
  amountNoteDefault: 'اتركه فارغاً لاستخدام المبلغ الافتراضي ({{default}})',
  amountNotePeriod: 'أدخل المبلغ للاشتراك {{type}}',
  summaryBusiness: 'المؤسسة:',
  summarySubType: 'نوع الاشتراك:',
  summaryCloudPlan: 'عرض السحابة:',
  summaryPrice: 'السعر:',
  summaryOwner: 'المالك:',
  summaryBusinessType: 'نوع المؤسسة:',
  summaryDecision: 'القرار:',
  approve: 'موافقة',
  renew: 'تجديد',

  cloudPlanLabel: 'السحابة',
  cloudPlanNone: 'محلي فقط',
  cloudPlanMirror: 'Cloud Mirror',
  cloudPlanHybrid: 'هجين متعدد الأجهزة',
  cloudPlanChoose: 'عرض السحابة (اختياري)',
  cloudPlanNoneTitle: 'محلي فقط',
  cloudPlanNoneDesc: 'نظام محلي دون مزامنة المبيعات/المشتريات/التقارير إلى السحابة.',
  cloudPlanMirrorTitle: 'Cloud Mirror',
  cloudPlanMirrorDesc: 'يدفع المبيعات والمشتريات والتقارير إلى Supabase للإدارة (نقطة البيع تبقى محلية).',
  cloudPlanHybridTitle: 'هجين متعدد الأجهزة',
  cloudPlanHybridDesc:
    'Mirror + مزامنة الكتالوج (منتجات، عملاء، موردون، دفعات) بين عدة نقاط بيع. المخزون المحلي يبقى المرجع.',

  reviewTitle: 'مراجعة الطلب - {{name}}',
  step1Title: 'الخطوة 1: اختيار القرار',
  step2Title: 'الخطوة 2: اختيار نوع الاشتراك',
  step3Title: 'الخطوة 3: التأكيد النهائي',
  reviewApproveTitle: 'الموافقة على المؤسسة',
  reviewApproveDesc: 'منح الوصول للنظام مع اشتراك',
  reviewSuspendTitle: 'تعليق المؤسسة',
  reviewSuspendDesc: 'رفض الوصول للنظام في الوقت الحالي',
  decisionApprove: '✅ موافقة',
  decisionSuspend: '❌ تعليق',
  decisionApproveLabel: 'موافقة',
  finalSummary: 'ملخص القرار الكامل',
  labelExpiryDate: 'تاريخ الانتهاء:',
  irreversibleAction: 'إجراء لا رجعة فيه',
  confirmApproveQuestion: 'هل أنت متأكد تماماً من الموافقة على هذه المؤسسة؟',
  confirmSuspendQuestion: 'هل أنت متأكد تماماً من تعليق هذه المؤسسة؟',
  approveWarningNote: 'سيمنح هذا الإجراء وصولاً كاملاً للنظام مع اشتراك نشط.',
  suspendWarningNote: 'سيعطل هذا الإجراء مؤقتاً وصول المؤسسة للنظام.',

  statusModalTitle: 'تعديل الحالة - {{name}}',
  chooseNewStatus: 'اختر الحالة الجديدة',
  suspendBusiness: 'تعليق المؤسسة',
  suspendDesc: 'تعطيل الوصول للنظام مؤقتاً',
  reactivateBusiness: 'إعادة تفعيل المؤسسة',
  reactivateDesc: 'إعادة تفعيل الوصول للنظام',
  currentStatus: 'الحالة الحالية:',
  currentSubscription: 'الاشتراك الحالي:',
  reactivate: 'إعادة التفعيل',
  suspend: 'تعليق',

  deleteTitle: '🗑️ حذف المؤسسة',
  deleteWarning: 'أنت على وشك حذف هذه المؤسسة وجميع بياناتها نهائياً.',
  deleteDetailsTitle: 'تفاصيل المؤسسة المراد حذفها',
  deleteConsequencesTitle: '⚠️ عواقب الحذف',
  deleteConsequence1: 'سيتم حذف جميع بيانات المؤسسة نهائياً',
  deleteConsequence2: 'ستُفقد جميع المنتجات والمبيعات والمشتريات والعملاء والموردين',
  deleteConsequence3: 'لن تتمكن المؤسسة من الوصول للنظام',
  deleteConsequence4: 'لا يمكن التراجع عن هذا الإجراء',
  deleteConfirmCheckbox: 'أفهم أن هذا الإجراء لا رجعة فيه وأؤكد رغبتي في حذف هذه المؤسسة',
  deleteConfirmButton: '🗑️ حذف نهائي',

  deleteSuccessTitle: '✅ تم الحذف بنجاح',
  deleteSuccessHeading: 'تم حذف المؤسسة بنجاح',
  deleteSuccessMessage: 'تم حذف المؤسسة "{{name}}" نهائياً من النظام.',
  deleteSuccessActionsTitle: 'الإجراءات المنفذة:',
  deleteSuccessAction1: '✅ حذف المؤسسة من قاعدة البيانات',
  deleteSuccessAction2: '✅ حذف جميع البيانات المرتبطة',
  deleteSuccessAction3: '✅ تنظيف التخزين المحلي',
  deleteSuccessAction4: '✅ تحديث قائمة المؤسسات',
  deleteSuccessNote: 'ملاحظة: هذا الإجراء لا رجعة فيه. لا يمكن للمؤسسة الوصول للنظام.',

  reviewSuccessApproveTitle: '✅ تمت الموافقة بنجاح',
  reviewSuccessSuspendTitle: '❌ تم التعليق بنجاح',
  reviewSuccessApproveHeading: 'تمت الموافقة على المؤسسة بنجاح',
  reviewSuccessSuspendHeading: 'تم تعليق المؤسسة بنجاح',
  reviewSuccessMessage: 'تم {{action}} المؤسسة "{{name}}" بنجاح.',
  actionApproved: 'الموافقة على',
  actionSuspended: 'تعليق',
  approvalDetailsTitle: 'تفاصيل الموافقة:',
  approvalStatusUpdated: '✅ تم تحديث الحالة:',
  approvalSubType: '✅ نوع الاشتراك:',
  approvalAmount: '✅ المبلغ:',
  approvalDate: '✅ تاريخ الموافقة:',
  approvalBy: '✅ وافق عليها:',
  approvalPaid: '✅ الدفع:',
  paid: 'مدفوع',
  suspendDetailsTitle: 'تفاصيل التعليق:',
  suspendStatusUpdated: '❌ تم تحديث الحالة:',
  suspendDate: '❌ تاريخ التعليق:',
  suspendBy: '❌ علّقها:',
  suspendAccess: '❌ الوصول للنظام:',
  blocked: 'محظور',

  unlockSuccessTitle: '🔑 تم إعادة توليد الرمز',
  unlockSuccessHeading: 'تم إعادة توليد رمز الفتح',
  unlockSuccessNote: 'ملاحظة: الرمز الجديد نشط الآن ويمكن استخدامه لفتح النظام في حالات الطوارئ.',

  errorClose: '❌ إغلاق',
  errorTitle: 'خطأ',
  errorNoInternet: 'لا يوجد اتصال بالإنترنت.',
  errorLoadFailed: 'تعذّر التحميل.',
  errorUnknown: 'خطأ غير معروف.',
  errorReportGen: 'خطأ أثناء إنشاء التقرير',
  errorReportGenWith: 'خطأ أثناء إنشاء التقرير: {{error}}',
  errorUnlockRegen: 'خطأ أثناء إعادة توليد رمز الفتح',
  errorUnlockRegenWith: 'خطأ أثناء إعادة التوليد: {{error}}',
  unlockRegenSuccess: 'تم إعادة توليد رمز الفتح بنجاح: {{code}}',
  errorPdfFailed: 'فشل إنشاء PDF',
  errorUpdateTitle: 'خطأ في التحديث',
  errorUpdateFailed: 'فشل تحديث حالة المؤسسة: {{error}}',
  errorGeneric: 'حدث خطأ: {{message}}',
  errorSuspendTitle: 'خطأ في التعليق',
  errorSuspendFailed: 'فشل تعليق المؤسسة. يرجى المحاولة مرة أخرى.',
  errorActivateTitle: 'خطأ في التفعيل',
  errorActivateFailed: 'فشل تفعيل المؤسسة. يرجى المحاولة مرة أخرى.',
  errorRetry: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  errorDeleteTitle: 'خطأ في الحذف',
  errorDeleteFailed: 'فشل الحذف: {{error}}',
  errorDeleteGeneric: 'حدث خطأ. يرجى التحقق من اتصالك والمحاولة مرة أخرى.',
  errorBusinessNotFoundTitle: 'المؤسسة غير موجودة',
  errorBusinessNotFound: 'لم يتم العثور على المؤسسة المطلوبة.',
  errorNoStatusSelected: 'لم يتم اختيار حالة',
  errorSelectStatus: 'يرجى اختيار حالة قبل المتابعة.',

  reportLoadingTitle: 'جاري تحميل التقرير...',
  reportLoadingDesc: 'جاري تحميل البيانات من Supabase...',
  reportNoDataTitle: 'لا توجد بيانات',
  reportNoDataDesc1: 'لم يتم العثور على بيانات تقرير لهذه المؤسسة.',
  reportNoDataDesc2: 'يجب على المؤسسة تسجيل الدخول ومزامنة بياناتها مع Supabase.',
  reportTitle: 'تقرير 28 يوماً - {{name}}',
  reportPeriod: 'الفترة:',
  reportPeriodRange: 'من {{start}} إلى {{end}}',
  reportBusiness: 'المؤسسة:',
  reportStockTitle: 'حركة المخزون لـ 28 يوماً',
  reportPoultryTitle: 'ملخص دورة الدواجن لـ 28 يوماً',
  reportColProduct: 'المنتج',
  reportColSuppliers: 'الموردون',
  reportColCustomers: 'العملاء',
  reportColPurchased: 'مُشترى',
  reportColSold: 'مُباع',
  reportColInStock: 'في المخزون',
  reportColPurchasePrice: 'سعر الشراء',
  reportColSellingPrice: 'سعر البيع',
  reportColMetric: 'المقياس',
  reportColQuantity: 'الكمية/القيمة',
  reportColDescription: 'الوصف',
  poultryPurchasedLive: 'دجاج حي مُشترى',
  poultrySoldLive: 'دجاج حي مُباع',
  poultrySoldSlaughtered: 'دجاج مذبوح مُباع',
  poultryPurchasedLiveDesc: 'دجاج حي مُشترى خلال آخر 28 يوماً',
  poultrySoldLiveDesc: 'دجاج حي مُباع خلال آخر 28 يوماً',
  poultrySoldSlaughteredDesc: 'دجاج مذبوح مُباع خلال آخر 28 يوماً'
};
